(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/drawselector/assets/javascripts/components/draw-selector.js') >= 0) return;  svs.modules.push('/components/sport/drawselector/assets/javascripts/components/draw-selector.js');

'use strict';

function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  DrawSelectorItem,
  DrawSelectorList
} = svs.sport.drawSelectorAssets;
class DrawSelector extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      showList: false
    });
    _defineProperty(this, "handleToggleList", () => {
      if (this.props.draws.length > 1) {
        this.setState(state => ({
          showList: !state.showList
        }));
      }
    });
    _defineProperty(this, "handleChangeDrawHandler", drawNumber => {
      this.setState({
        showList: false
      });
      this.props.selectDraw(drawNumber);
    });
  }
  renderDropDownArrow() {
    if (this.props.draws.length < 2) {
      return null;
    }
    const iconClassName = "icon-default js-caret".concat(this.state.showList ? ' icon-menu-up' : ' icon-menu-down');
    return React.createElement("div", {
      className: "right-side"
    }, React.createElement("i", {
      className: iconClassName
    }));
  }
  render() {
    const {
      draws,
      drawNumber,
      onToggle,
      branding
    } = this.props;
    const currentDraw = this.props.draws.filter(draw => draw.drawNumber === drawNumber)[0];
    const headerClassName = "draw-selector-header".concat(draws.length > 1 ? ' pointer' : '', " ").concat(branding);
    return React.createElement("div", {
      id: "draw-selector"
    }, React.createElement("div", {
      className: headerClassName,
      onClick: this.handleToggleList
    }, React.createElement("div", {
      className: "left-side"
    }, React.createElement(DrawSelectorItem, {
      draw: currentDraw,
      partOfList: false
    })), this.renderDropDownArrow()), React.createElement(DrawSelectorList, {
      draws: draws,
      onChangeDrawHandler: this.handleChangeDrawHandler,
      onToggle: onToggle,
      selectedDraw: drawNumber,
      showList: this.state.showList
    }));
  }
}
setGlobal('svs.sport.DrawSelector', DrawSelector);

 })(window);